import React, { useState } from "react";
import { Box, CircularProgress } from "@mui/material";

function DgButton({ 
  category, 
  size, 
  text, 
  action, 
  children, 
  loading, 
  style,
  zIndex
}) {
  return (
    <button
      onClick={action}
      className={`${category} ${size}`}
      disabled={loading}
      style={{ 
        ...style,
        zIndex: zIndex 
      }}
    >
      <span>
        {text}
        {children}
      </span>
      {loading && (
        <Box sx={{ display: "flex", marginLeft: "1.25rem" }}>
          <CircularProgress style={{ width: "20px", height: "20px" }} />
        </Box>
      )}
    </button>
  );
}

export default DgButton;
